import React, { useState, useRef, useEffect } from 'react';
import './monthly-dropdown.scss';
import customAxios from "../../../service/api/interceptors";
import {useOnClickOutside} from "../../../hooks/useOnClickOutside"; // Импорт стилей


const MonthlyTargetsDropdown = () => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    useOnClickOutside({ ref: dropdownRef, handler: () => setIsOpen(false) })
    const [numbers, setNumbers] = useState({
        estimated: {
            "title": "Estimated Credits",
            "current_number": 0,
            "target_number": 0,
            "current_percentage": 0,
            "previous_percentage": 0
        },
        redeemed: {
            "title": "Redeemed Credits",
            "current_number": 0,
            "target_number": 0,
            "current_percentage": 0,
            "previous_percentage": 0
        },
        settled: {
            "title": "Settled Credits",
            "current_number": 0,
            "target_number": 0,
            "current_percentage": 0,
            "previous_percentage": 0
        }
    })

    const getData = async () => {
        const { status, data } = await customAxios.get(`/company/manager/kanban/targets`)
        if (status === 200) {
            setNumbers(data)
        }
    }

    useEffect(() => {
        getData()
    }, []);

    return (
        <div className="mt-dropdown-container" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="mt-trigger-btn"
                aria-label="Toggle menu"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
            </button>

            {isOpen && (
                <div className="mt-menu">
                    <h3 className="mt-title">Monthly Targets</h3>

                    <div className="mt-list">
                        <div className="mt-item">
                            <div className="mt-item-left">
                                <div className="mt-icon-check">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                </div>

                                <div className="mt-text-block">
                                        <span className="mt-label">
                                          Estimated Credits: {numbers.estimated.current_number}/{numbers.estimated.target_number}
                                        </span>
                                    <span className="mt-sublabel">Previous Result: {numbers.estimated.previous_percentage}%</span>
                                </div>
                            </div>

                            <span className="mt-percentage">
                                  {numbers.estimated.current_percentage}%
                                </span>
                        </div>

                        <div className="mt-item">
                            <div className="mt-item-left">
                                <div className="mt-icon-check">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                </div>

                                <div className="mt-text-block">
                                        <span className="mt-label">
                                          Redeemed Credits: {numbers.redeemed.current_number}/{numbers.redeemed.target_number}
                                        </span>
                                    <span className="mt-sublabel">Previous Result: {numbers.redeemed.previous_percentage}%</span>
                                </div>
                            </div>

                            <span className="mt-percentage">
                                  {numbers.redeemed.current_percentage}%
                                </span>
                        </div>

                        <div className="mt-item">
                            <div className="mt-item-left">
                                <div className="mt-icon-check">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                </div>

                                <div className="mt-text-block">
                                        <span className="mt-label">
                                          Settled Credits: {numbers.settled.current_number}/{numbers.settled.target_number}
                                        </span>
                                    <span className="mt-sublabel">Previous Result: {numbers.settled.previous_percentage}%</span>
                                </div>
                            </div>

                            <span className="mt-percentage">
                                  {numbers.settled.current_percentage}%
                                </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MonthlyTargetsDropdown;